import { AppBar, Box, Toolbar, Typography } from "@mui/material";

const PaymentHeader = () => {
	return (
		<AppBar position="static" color="primary" elevation={0}>
			<Toolbar>
				<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<Typography
						variant="h6"
						component="div"
						sx={{
							color: "white",
							fontWeight: "bold",
							letterSpacing: 1,
						}}
					>
						Garantti
					</Typography>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export default PaymentHeader;
